<template>
    <div>
        <v-toolbar app>
            <v-toolbar-title>
                <router-link to="/" class="home-link">TrackerSync</router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn flat to="/config">Configurar proveedores</v-btn>
                <v-btn flat to="/config-system">Configurar sistema</v-btn>
            </v-toolbar-items>

            <v-avatar size="48px" class="ml-4">
                <img :src="currentUser.picture"/>
            </v-avatar>
        </v-toolbar>


        <v-content>
            <v-container fluid>
                <router-view :key="$route.fullPath"></router-view>
            </v-container>
        </v-content>

        <v-footer class="pa-3" app>
            <v-spacer></v-spacer>
            Made with <v-icon size="16" color="red darken-4" class="mr-1 ml-1">favorite</v-icon> by Front.id &copy; {{ new Date().getFullYear() }}
        </v-footer>
    </div>
</template>


<script>
  import {mapState} from "vuex"

  export default {
    name: 'App',
    data() {
      return {}
    },

    computed: {
      ...mapState([
        'currentUser',
      ]),
    },

  }
</script>

<style lang="scss">
</style>